<template>
  <div class="card">
    <div class="d-flex justify-space-between">
      <div class="card-time">
        <base-image :info="$app.images.badgeColor" />
        {{ formatedDate }}
      </div>
    </div>
    <div class="divider" />
    <div class="d-flex justify-space-between">
      <span class="fw-500">{{ formatedTime }}</span>
      <span class="card-created">
        Created:
        <span class="fw-500 ml-1">{{ info.created_by }}</span>
      </span>
    </div>
  </div>
</template>

<script>
import BaseImage from '@/components/BaseImage'

export default {
  name: "ComparisonDescription",
  components: {
    BaseImage,
  },
  props: {
    info: {
      type: Object,
      required: true,
    }
  },
  computed: {
    formatedDate() {
      return new Date(this.info?.created_date).toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric' })
    },
    formatedTime() {
      return new Date(this.info?.created_date).toLocaleDateString('en-Gb', { year: 'numeric', month: 'short', day: 'numeric' })
    },
  },
}
</script>

<style lang="scss" scoped>
.card {
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-width: 768px;
  color: var(--v-grey-lighten-1);
  font-size: 14px;
  line-height: 24px;
}

.card-time {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 700;
}

.card-created {
  color: var(--v-grey-lighten-2);
}

.divider {
  min-height: 2px;
  width: 100%;
  background: var(--v-grey-lighten-2);
}
</style>
